export const FETCH_RECOMMENDED_FOODS = "FETCH_RECOMMENDED_FOODS"
export const ADD_RECOMMENDED_FOODS = "ADD_RECOMMENDED_FOODS"
export const UPDATE_RECOMMENDED_FOODS = "UPDATE_RECOMMENDED_FOODS"
export const DELETE_RECOMMENDED_FOODS = "DELETE_RECOMMENDED_FOODS"